
import React, { useState } from "react";
import { Formik, Form } from "formik";
import { workshopVoiceSchema } from "./workshopVoiceSchema";
import _ from "lodash";
import { Container, Row, Col, Card, CardBody } from "reactstrap";
import moment from "moment";
import { WorkshopForm } from "./workshopForm";
import { store } from "../../redux/storeConfig/store";
import { toastr } from "react-redux-toastr";
import { createClass } from "../../redux/actions/api/apiAction";
import {
  checkIfTimesWithenTrainerSchedule,
  getClassDatesObject,
} from "./utils";
import { setForceAddModalOpen } from "../../redux/actions/class/classAction";
import { DateHelper } from "../../helper/helpers";
import { useSelector } from "react-redux";
import { addWorkshopModal } from "../../redux/actions/sidebar/sidebarAction";
import {
  saveVoiceDraftEdit,
  voiceReviewActionLabel,
} from "../voiceAdd/saveDraftEdit";
import { withVoicePrefill } from "../voiceAdd/openForm";

const WorkshopMain = () => {
  const formSchema1 = workshopVoiceSchema;

  const { trainer: selectedTrainer } = useSelector((state) => state.trainer);
  const voicePrefill = useSelector(
    (state) => state.voiceAdd && state.voiceAdd.prefill
  );
  const voiceFields =
    voicePrefill && voicePrefill.type === "workshop"
      ? voicePrefill.fields || {}
      : {};

  const submit = async (values) => {
    if (saveVoiceDraftEdit(values)) return;
    let {
      bookingWindowEnd,
      bookingWindowStart,
      startDate,
      endDate,
      classDates,
      bookingStartUnit,
      bookingEndUnit,
      cancelBefore,
      cancelationWindowUnit,
      timesArray,
      numberOfSessions,
    } = values;

    const { scheduleDays } = selectedTrainer;

    let openForceAddModal;

    let datesObj = {};

    const classDays = classDates.map((date) => {
      let dayString = DateHelper.GetFullDayString(parseInt(date));
      let arr = [];
      for (let i = 0; i < timesArray.length; i++) {
        const element = timesArray[i];
        arr.push({
          start: element.from,
          end: element.to,
        });
      }
      datesObj[dayString] = arr;
      arr = [];
      return dayString;
    });

    // openForceAddModal = !checkIfTimesWithenTrainerSchedule(
    //   classDays,
    //   scheduleDays,
    //   datesObj
    // );

    // if (openForceAddModal) {
    //   store.dispatch(setForceAddModalOpen(true));
    // }

    const datesToSend = [startDate, endDate].map((item) => item.getTime());

    let timeForDates = [];
    let correctDateTimes = values.classDates.map((date) => {
      let dateString = moment(date).format("DD/MM/yyyy");
      for (let index = 0; index < timesArray.length; index++) {
        const element = timesArray[index];
        timeForDates.push({
          from: parseInt(
            moment(dateString + " " + element.from, "DD/MM/yyyyLT").format("x")
          ),
          to: parseInt(
            moment(dateString + " " + element.to, "DD/MM/yyyyLT").format("x")
          ),
        });
      }
    });
    try {
      let datesWithBookings = getClassDatesObject(
        bookingWindowStart,
        bookingWindowEnd,
        timeForDates,
        bookingStartUnit,
        bookingEndUnit,
        cancelBefore,
        cancelationWindowUnit
      );

      let req = _.cloneDeep(values);
      req.classDates = datesWithBookings;
      [("startDate", "endDate")].forEach((item, idx) => {
        req[item] = datesToSend[idx];
      });

      req.startDate = datesToSend[0];
      req.endDate = datesToSend[1];

      req.payrateId =
        req?.payRates && req?.payRates.length && req?.payRates[0]?.id;

      /** here handle waiting lsit capacity */
      // if (waitingListCapacity && waitingListCapacity > 0) {
      //   req.waitingListRule = "auto";
      //   req.waitingList = true;
      // }
      if (numberOfSessions > req.classDates.length) {
        return toastr.error(
          ` Number of sessions ${numberOfSessions} is greater that workshop/course days ${classDates.length}`
        );
      }
      req.assignedPackages = [];
      console.log({ req });
      store.dispatch(createClass(req));
    } catch (e) {
      toastr.error(e.message);
    }
  };

  const renderStep = (values, errors, touched, setFieldValue) => {
    return (
      <WorkshopForm
        errors={errors}
        touched={touched}
        values={values}
        setFieldValue={setFieldValue}
      />
    );
  };
  return (
    <Container
      fluid
      className="p-4 workshop-container"
      style={{ backgroundColor: "#f8f9fa", minHeight: "100vh", width: "100%" }}
    >
      <Row className="justify-content-center">
        <Col lg={12} xl={12}>
          <Card className="shadow-sm border-0" style={{ borderRadius: "12px" }}>
            <CardBody className="p-4">
              <div className="d-flex align-items-center mb-4">
                <h4 className="mb-0 fw-bold workshop-container title">
                  Add Workshop/Course
                </h4>
              </div>
              <div
                style={{
                  height: "2px",
                  borderWidth: "1px",
                  backgroundColor: "#EEEEEE",
                }}
              ></div>
              <Formik
                enableReinitialize
                initialValues={withVoicePrefill("workshop", {
                  name: "",
                  preRequisites: "",
                  description: "",
                  notes: "",
                  groupType: "workshop",
                  type: "OFFLINE",
                  waitingListCapacity: 0,
                  capacity: "",
                  packagePrice: "",
                  packageName: "",
                  packageDuration:"",
                  numberOfSessions: "",
                  payRates: null,
                  waitingList: false,
                  freeTrial: false,
                  trainer: undefined,
                  startDate: new Date(),
                  endDate: new Date(),
                  to: "",
                  from: "",
                  tax: "",
                  waitingListRule: "",
                  autoCreateSinglePackage: false,
                  allowCancelation: true,
                  allowUnpaidBooking: false,
                  noShowDeduction: false,
                  classDates: [],
                  bookingWindowEnd: "",
                  bookingStartUnit: "d",
                  bookingEndUnit: "d",
                  cancelationWindowUnit: "h",
                  cancelBefore: "1",
                  timesArray: [],
                  gender: "",
                  disableOnlineBooking: true,
                  court: null,
                  showTrainer: true,
                  ...voiceFields,
                })}
                onSubmit={submit}
                validationSchema={formSchema1}
              >
                {({ errors, touched, values, setFieldValue }) => (
                  <>
                    <Form>
                      {renderStep(values, errors, touched, setFieldValue)}

                      <div className="bg-white card-panel ex-space-y pt-0">
                        <div className="action-wrapper blk-padding-y">
                          <div className="action-inner-block">
                            <div className="action-btn-block">
                              <button
                                type="button"
                                className="btn btn-medium btn-transparent"
                                onClick={() => {
                                  store.dispatch(addWorkshopModal(false));
                                }}
                              >
                                Cancel
                              </button>
                              <button className="btn btn-medium" type="submit">
                                {voiceReviewActionLabel("Save")}
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Form>
                  </>
                )}
              </Formik>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default WorkshopMain;